import { Component, OnInit, Input } from '@angular/core';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { PermissionHelper, ComponentID, ActionType } from '../../../shared/helpers/permissionshelper';

@Component({
  selector: 'app-apps-sidebar',
  templateUrl: './apps-sidebar.component.html',
  styleUrls: []
})
export class AppsSidebarComponent implements OnInit {

  constructor(private helpers : HelpersService,
    public permhelper:PermissionHelper, 
    public componentid : ComponentID ,
    public actiontype: ActionType)  { }

  @Input() activeRoute:string;
  
  ngOnInit() {
    
  }

  Helpers(){
    return this.helpers;
  }

  hasPermission( pageid:string, action :string) : Boolean
  {
    return this.permhelper.hasPermission(pageid, action);
  }
 
  hasPermissionForOthers( pageid:string, action :string, userid:any) : Boolean
  {
    return this.permhelper.hasPermissionForOthers(pageid,action,userid);
  }

}



// WEBPACK FOOTER //
// ./src/app/client/apps/apps-sidebar/apps-sidebar.component.ts